import { BulbOutlined } from '@ant-design/icons';

const BulbOutlinedIlluminated = () => {
  return (
    <BulbOutlined 
      style={{ 
        color: '#ffca28', // Primary color.
        fontSize: '20px', 
        filter: 'drop-shadow(0 0 6px rgba(255, 202, 40, 0.8))', // Glow Effect
        verticalAlign: 'middle'
      }} 
    />
  );
};

export default BulbOutlinedIlluminated;
